// Light first (Ruben, 2026-11-01): the console and its sign-in open light,
// even on a Mac set to dark, unless this computer chose otherwise with the
// theme button. A new storage key, because the old one saved « system » on
// its own and kept dark Macs in dark; the choice is saved only on a press.

export type Theme = 'system' | 'light' | 'dark';
export const THEMES: Theme[] = ['light', 'dark', 'system'];
const KEY = 'mygaz-ops-theme';

export function readTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY);
    return t === 'dark' || t === 'system' ? t : 'light';
  } catch { return 'light'; }
}

export function applyTheme(t: Theme) {
  const r = document.documentElement;
  if (t === 'system') r.removeAttribute('data-theme'); else r.setAttribute('data-theme', t);
}

export function saveTheme(t: Theme) {
  try { localStorage.setItem(KEY, t); } catch { /* private window */ }
}
